module.exports = __webpack_public_path__ + "static/Ashwin--543aee5cf27c57cde60e1999dc900c5c.jpg";